import { SystemStyleObject } from "@chakra-ui/react";

export const businessAccountDetailDropDownBtnCss: SystemStyleObject = {
  boxShadow: "none",
  padding: 0,
  width: "100%",
  height: "36px",
};

export const businessAccountDetailDropDownPopUpMenuContentCss: SystemStyleObject =
  {
    width: "240px",
    height: "161px",
    borderRadius: "8px",
    backgroundColor: "#ffffff",
    border: "1px solid #F2F4F7",
    boxShadow: "0px 12px 16px -4px #10182814",
    padding: "0 16px",
  };
